import { Box, CircularProgress, FormControl, Grid, MenuItem } from "@material-ui/core";
import CloseIcon from '@mui/icons-material/Close';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { Autocomplete, Button, TextField, Tooltip } from "@mui/material";
import Backdrop from '@mui/material/Backdrop';
import Fade from '@mui/material/Fade';
import Modal from '@mui/material/Modal';
import 'dayjs/locale/en-gb';
import { asBlob, generateCsv, mkConfig } from 'export-to-csv';
import { jwtDecode } from "jwt-decode";
import { MaterialReactTable } from "material-react-table";
import { useEffect, useMemo, useState } from 'react';
import Swal from "sweetalert2";
import PageTitle from "../../../components/PageTitle/PageTitle";
import axios from "../../../utils/axios";
import { formatNumberInWords, formatNumberSeparatedByCommas } from "../../../utils/strings/Localization";

const ForwardingLetterDashboard = () => {
  // Get User ID from Token
  const token = localStorage.getItem("bearer-token");
  const decoded = jwtDecode(token);
  const userId = decoded.id;
  const currentDate = new Date().toISOString().split("T")[0];

  const [issuer, setIssuer] = useState("All");
  const [dividendType, setDividendType] = useState("All");
  const [fromDate, setFromDate] = useState("")
  const [toDate, setToDate] = useState("")
  const [tableData, setTableData] = useState([]);
  const [issuerList, setIssuerList] = useState([{ id: "All", displayName: "All (All Companies)" }]);
  const [loadingIssuers, setLoadingIssuers] = useState(false);
  const [loadingTable, setLoadingTable] = useState(false);
  const [error, setError] = useState(null);
  const [totalEntry, setTotalEntry] = useState(0);
  const [totalInitiated, setTotalInitiated] = useState(0);
  const [totalPending, setTotalPending] = useState(0);
  const [totalApproved, setTotalApproved] = useState(0);
  const [totalDeclined, setTotalDeclined] = useState(0);
  const [ApprovalStatus, setApprovalStatus] = useState("All");

  // Map Dividend Type to Numeric Values
  const getDividendTypeValue = (type) => {
    switch (type) {
      case "Cash": return "Cash";
      case "Stock": return "Stock";
      default: return "All";
    }
  };

  // Fetch Issuer List
  useEffect(() => {
    const fetchIssuerNames = async () => {
      setLoadingIssuers(true);
      try {
        const { data } = await axios.get("/issuer/get-info");
        if (data?.payload) {
          const formattedIssuerList = data.payload.map((issuer) => ({
            id: issuer.id,
            displayName: `${issuer.name} (${issuer.tradecode})`,
          }));
          setIssuerList([{ id: "All", displayName: "All (All Companies)" }, ...formattedIssuerList]);
        }
      } catch (error) {
        console.error("Error fetching issuer names:", error);
      } finally {
        setLoadingIssuers(false);
      }
    };

    fetchIssuerNames();
  }, []);

  // Fetch Table Data

  const fetchTableData = async () => {
      setLoadingTable(true);
      setError(null);
      try {

        const payload = {
          p_dashboardType: 0,
          p_issuerId: issuer === "All" ? "All" : issuer,
          p_dividendType: getDividendTypeValue(dividendType),
          p_userId: userId,
          p_fromDate: fromDate,
          p_toDate: toDate,
          p_approvalStatus: ApprovalStatus === "All" ? "All" : ApprovalStatus,
        };

        const response = await axios.post("settlement/get-forward-letter-info", payload);
        if (response.data?.payload) {
          if (response.data.payload.length === 0) {
            // Swal.fire({
            //   icon: "info",
            //   title: "No Data Found",
            //   text: "No data found for the selected filters.",
            // });
            setError("No data found for the selected filters.");
          }
          else{
            setTableData(response.data.payload);
            setTotalEntry(response.data.payload[0].tentry);
          setTotalInitiated(response.data.payload[0].tinitiated);
          setTotalPending(response.data.payload[0].tpending);
          setTotalApproved(response.data.payload[0].tapproved);
          setTotalDeclined(response.data.payload[0].tdenied);
          }
          
        } else {
          setTableData([]);
          setTotalEntry(0);
          setTotalInitiated(0);
          setTotalPending(0);
          setTotalApproved(0);
          setTotalDeclined(0);
        }
      } catch (error) {
        console.error("Error fetching table data:", error);
        setError("Failed to load data. Please try again.");
      } finally {
        setLoadingTable(false);
      }
    };
  useEffect(() => {
    // const fetchTableData = async () => {
    //   setLoadingTable(true);
    //   setError(null);
    //   try {

    //     const payload = {
    //       p_dashboardType: 0,
    //       p_issuerId: issuer === "All" ? "All" : issuer,
    //       p_dividendType: getDividendTypeValue(dividendType),
    //       p_userId: userId,
    //       p_fromDate: fromDate,
    //       p_toDate: toDate,
    //       p_approvalStatus: ApprovalStatus === "All" ? "All" : ApprovalStatus,
    //     };

    //     const response = await axios.post("settlement/get-forward-letter-info", payload);
    //     if (response.data?.payload) {
    //       if (response.data.payload.length === 0) {
    //         // Swal.fire({
    //         //   icon: "info",
    //         //   title: "No Data Found",
    //         //   text: "No data found for the selected filters.",
    //         // });
    //         setError("No data found for the selected filters.");
    //       }
    //       else{
    //         setTableData(response.data.payload);
    //         setTotalEntry(response.data.payload[0].tentry);
    //       setTotalInitiated(response.data.payload[0].tinitiated);
    //       setTotalPending(response.data.payload[0].tpending);
    //       setTotalApproved(response.data.payload[0].tapproved);
    //       setTotalDeclined(response.data.payload[0].tdenied);
    //       }
          
    //     } else {
    //       setTableData([]);
    //       setTotalEntry(0);
    //       setTotalInitiated(0);
    //       setTotalPending(0);
    //       setTotalApproved(0);
    //       setTotalDeclined(0);
    //     }
    //   } catch (error) {
    //     console.error("Error fetching table data:", error);
    //     setError("Failed to load data. Please try again.");
    //   } finally {
    //     setLoadingTable(false);
    //   }
    // };

    
    
    if((fromDate && toDate ) || (!fromDate && !toDate ) )
    {
      fetchTableData();
    }
    else{
      setTableData([]);
      setTotalEntry(0);
          setTotalInitiated(0);
          setTotalPending(0);
          setTotalApproved(0);
          setTotalDeclined(0);
    }
  }, [issuer, dividendType, userId, fromDate, toDate, ApprovalStatus]);

  // Define Table Columns
  const columns = useMemo(() => [
    {
      accessorKey: 'id',
      header: 'SL',
      size: 2,
      Cell: ({ row }) => (
        <div style={{ textAlign: "center"}}>
          {row.index + 1}
        </div>
      ),
    },
    { accessorKey: "docketingno", header: "Docketing No", size: 30 },
    { accessorKey: "issuerid", header: "Issuer Name / Sender Name", size: 5,
      Cell: ({ row }) => {
        return row.original.dividendtype === "Others" ?  row.original.company_name : row.original.issuerid
      },
      
      muiTableBodyCellProps: {
        sx: {
          width: '100px',
          maxWidth: '120px',
          wordBreak: 'break-word',
          whiteSpace: 'normal',
          border: '1px solid rgba(224, 224, 224, 1)'
        },
      }
    },
    {
  accessorKey: "dividendtype",
  header: "Dividend Type",
  size: 2,
},
{ accessorKey: "subject", header: "Subject", size: 30 },
{ accessorKey: "ref_no", header: "Reference No", size: 30 },

    { accessorKey: "dividendyear", header: "Year", size: 50,
   muiTableBodyCellProps: {
    sx: {
      width: '100px',
      maxWidth: '100px',
      wordBreak: 'break-word',
      whiteSpace: 'normal',
      padding: '4px',
      border: '1px solid rgba(224, 224, 224, 1)'
    }
  },
  Cell: ({ cell }) => {
    const years = cell.getValue();
    if (!years) return '';
    
    // Clean and split the years string
    const yearArray = years.split(',')
      .map(year => year.trim())
      .filter(year => year); // Remove empty values
      
    // Create groups of 3 years
    let formattedYears = '';
    for (let i = 0; i < yearArray.length; i++) {
      formattedYears += yearArray[i];
      if (i < yearArray.length - 1) {
        if ((i + 1) % 3 === 0) {
          formattedYears += '\n';
        } else {
          formattedYears += ', ';
        }
      }
    }
    
    return (
      <div style={{ 
        whiteSpace: 'pre-wrap',
        lineHeight: '1',
        fontSize: '12px',
        textAlign: 'left'
      }}>
        {formattedYears}
      </div>
    );
  }
},
    { accessorKey: "amount", header: "Net Amount", size: 30,
      Cell: ({ cell }) => {
        const value = cell.getValue();
        const formatted = value ? `${formatNumberSeparatedByCommas(value)}` : '';
        const inWords = value ? formatNumberInWords(value) : '';
        return (
      <Tooltip title={inWords} arrow placement="top">
        <span>{formatted}</span>
      </Tooltip>
    );
      },
      muiTableBodyCellProps: {
        sx: {
          width: '100px',
          maxWidth: '120px',
          wordBreak: 'break-word',
          whiteSpace: 'normal',
          border: '1px solid rgba(224, 224, 224, 1)'
        },
      }
     },
    //  { accessorKey: "amountInWords", header: "In Words", size: 30,
    //   Cell: ({ row }) => {
    //     const value = row.original.amount;
    //     return value ? formatNumberInWords(value) : '';

    //   },
    //   muiTableBodyCellProps: {
    //     sx: {
    //       width: '100px',
    //       maxWidth: '120px',
    //       wordBreak: 'break-word',
    //       whiteSpace: 'normal',
    //       border: '1px solid rgba(224, 224, 224, 1)'
    //     },
    //   }
    //  },
    

    { accessorKey: "receiveddate", header: "Incoming Letter Recieve Date", size: 30 },
    { accessorKey: "paymentdate", header: "Bank/BO Recieved Date", size: 30 },
    {
      accessorKey: "images",
      header: "Incoming Letter",
      size: 10,
      
      Cell: ({ row }) => {
        // Local state to handle preview dialog visibility
        const [openPreview, setOpenPreview] = useState(false);
        const [filePreview, setFilePreview] = useState('');

        const style = {
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '60%',
          bgcolor: 'background.paper',
          border: '2px solid #eee',
          boxShadow: '2px 2px 2px 2px #eee',
          borderRadius: "10px",
          p: 4
        };


        const handlePreviewClick = async () => {
          try {
            const fileUrlfromDB = row.original.images[0];  // Access the file URL from the row
            const fileURLclean = fileUrlfromDB.replace(/^\["|"\]$/g, '');
            const response = await axios.post(`/settlement/get-settlement-file/37`, { filename: fileURLclean },
              { responseType: 'blob' });
            const file = new Blob([response.data], { type: 'application/pdf' });
            const fileUrl = URL.createObjectURL(file);


            if (fileUrl) {
              setFilePreview(fileUrl); // Set the file preview URL
            }
            setOpenPreview(true);
          }
          catch (error) {
            console.error("Error fetching PDF:", error);

            // Check if the error is a 404 Not Found
            if (error.response && error.response.status === 404) {
              Swal.fire({
                icon: "warning",
                title: "File Not Found",
                text: "The requested PDF file was not uploaded on the server.",
              });
            } else {
              // Handle other errors
              Swal.fire({
                icon: "error",
                title: "Error",
                text: "Something went wrong while fetching the file!",
              });
            }
          }
        };
        const openModal = () => {
          return (
            <Modal
              aria-labelledby="transition-modal-title"
              aria-describedby="transition-modal-description"
              open={openPreview}
              onClose={() => setOpenPreview(false)}
              closeAfterTransition
              BackdropComponent={Backdrop}
              slots={{ backdrop: Backdrop }}
              slotProps={{
                backdrop: {
                  timeout: 500,
                }
              }}
              style={{
                overflow: "auto", display: "flex", justifyContent: "center", alignItems: "center", textAlign: "center", borderRadius: "10px"
              }}
            >
              <Fade in={openPreview}>
                <Box sx={style} style={{ textAlign: "center", width: "80%", height: "95vh" }} >
                  <h3>PDF VIEWER </h3>



                  <Box className="form-control" style={{ textAlign: "center", height: "90%" }}>

                    {
                      // filePreview ? 

                      filePreview ? (
                        <embed src={filePreview} width="100%" height="93%" type="application/pdf" />
                      )
                        :
                        (
                          <div
                            style={{
                              alignItems: 'center',
                              border: '2px dashed rgba(0, 0, 0, .3)',
                              fontSize: '2rem',
                              height: '100%',
                              display: "flex",
                              justifyContent: 'center',
                              width: '100%',
                              marginBottom: "5px"
                            }}
                          >
                            View Area<br />
                            Oops! The file is not uploaded yet.
                          </div>
                        )
                    }


                    <Button type="button" onClick={() => { setOpenPreview(false); }} variant="contained" color="info" style={{ color: "white" }}><CloseIcon /> Close</Button>
                  </Box>



                </Box>
              </Fade>
            </Modal>
          )
        }

        return (
          <div style={{ textAlign: "center",margin:0 ,padding: 0}}>
            <Button variant="contained" color="primary" onClick={handlePreviewClick}>
              View
            </Button>
            {
              openPreview && openModal()
            }
          </div>
        );
      },
    },

    { accessorKey: "fullname", header: "Incoming Letter Uploaded By", size: 30 },
    {
      accessorKey: "createdat",
      header: "Incoming Letter Upload Date",
      size: 30,
      Cell: ({ cell }) => new Date(cell.getValue()).toLocaleString("en-GB", {
        year: "numeric",  
        month: "2-digit",
        day: "2-digit",
      }),
    },
    { accessorKey: "notes", header: "Note", size: 30 },
    { accessorKey: "accountstatus", header: "Verification Status", size: 30,
      Cell: ({ cell }) => {
        const status = cell.getValue();
        return (
          <Button color={status==="Approved" ? "success" : status==="Declined" ? "error" : status==="Pending" ? "warning" : "primary" } variant="contained" >
            {status}
          </Button>
        );
      }
     },
    { accessorKey: "approvedby", header: "Verified By", size: 30 },
    {
  accessorKey: "approvedat",
  header: "Verified At",
  size: 30,
  Cell: ({ cell }) => {
    const value = cell.getValue();
    return value
      ? new Date(value).toLocaleString("en-GB", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit"
        })
      : "";
  },}
  ], []);

    const csvConfig = mkConfig({
    fieldSeparator: ',',
    decimalSeparator: '.',
    useKeysAsHeaders: true,
  });
  const handleExportData = () => {
    const tableDataForExport = tableData.map((row) => ({
      ...row,
      paymentdate: row.paymentdate ? new Date(row.paymentdate).toLocaleDateString("en-GB") : "",
      receiveddate: row.receiveddate ? new Date(row.receiveddate).toLocaleDateString("en-GB") : "",
      createdat: row.createdat ? new Date(row.createdat).toLocaleDateString("en-GB") : "",
      images: ""
    }));
    // console.log("Exporting data to CSV..." , tableDataForExport);
    const csv = generateCsv(csvConfig)(tableDataForExport);
    const blob = asBlob(csvConfig)(csv);
    const fileURL = URL.createObjectURL(blob);
    var link = document.createElement("a");
    link.href = fileURL;
    link.setAttribute("download", `Incoming Letter List.csv`);
    link.click();
    // download(csvConfig)(csv);
  };
const rowSizeOptions = [5, 10, 15, 20, 25, 30, 50, 100,200,500];
const maxOption = tableData.length;
const rowsPerPageOptions = [
  ...rowSizeOptions.filter(opt => opt < maxOption).sort((a, b) => a - b),
  maxOption,
];


  return (
    <>
      <PageTitle title="Incoming Letter Dashboard" />

      {/* Dropdown Filters */}
      <Grid container spacing={2} style={{ marginBottom: "20px" }}>
        {/* Issuer Dropdown */}
        <Grid item lg={3} md={4} sm={12} xs={12}>
          <FormControl fullWidth>
            <Autocomplete
              options={issuerList}
              getOptionLabel={(option) => option.displayName}
              value={issuerList.find((item) => item.id === issuer) || null}
              onChange={(_, newValue) => setIssuer(newValue ? newValue.id : "All")}
              loading={loadingIssuers}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Issuer Name / Sender Name"
                  variant="outlined"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {loadingIssuers ? <CircularProgress size={24} /> : null}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                />
              )}
            />
          </FormControl>
        </Grid>

        {/* Dividend Type Dropdown */}
        <Grid item lg={2} md={2} sm={12} xs={12}>
          <FormControl fullWidth>
            <TextField
              select
              label="Dividend Type"
              value={dividendType}
              onChange={(e) => setDividendType(e.target.value)}
              variant="outlined"
            >
              <MenuItem value="All">All</MenuItem>
              <MenuItem value="Cash">Cash</MenuItem>
              <MenuItem value="Stock">Stock</MenuItem>
            </TextField>
          </FormControl>
        </Grid>
        <Grid item lg={2} md={2} sm={12} xs={12}>
          <FormControl fullWidth>
            <TextField
              select
              label="Verification Status"
              defaultValue="All"
              value={ApprovalStatus}
              onChange={(e) => setApprovalStatus(e.target.value)}
              variant="outlined"
            >
              <MenuItem value="All">All</MenuItem>
              <MenuItem value="Initiated">Initiated</MenuItem>
              <MenuItem value="Pending">Pending</MenuItem>
              <MenuItem value="Approved">Approved</MenuItem>
              <MenuItem value="Declined">Declined</MenuItem>
            </TextField>
          </FormControl>
        </Grid>
        <Grid item lg={2} md={2} sm={12} xs={12}>
          <TextField
            label="From Date"
            type="date"
            variant="outlined"
            fullWidth
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{
              //max: `${currentDate && data.cmsfReceivedOnDate}`,
            }}
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
          />
        </Grid>

        <Grid item lg={2} md={2} sm={12} xs={12} style={{ textAlign: "center" }}>
          <TextField
            label="To Date"
            type="date"
            variant="outlined"
            fullWidth
            disabled={!fromDate} // Disable if fromDate is not set
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{
              max: `${currentDate}`,
              //min: `${data.issuerSentOnDate}`
              min: fromDate || "",  // Disable dates before fromDate
            }}
           
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
          />
          {fromDate && !toDate ? <span style={{color:"red"}}>Please select to date</span> : null}
        </Grid>
      </Grid>

      {/* Table */}
      {loadingTable ? (
        <CircularProgress size={40} style={{ display: "block", margin: "20px auto" }} />
      ) : error ? (
        <p style={{ textAlign: "center", color: "red" }}>{error}</p>
      ) : (
        <Grid style={{ padding: "17px", }}>
          <MaterialReactTable
            columns={columns}
            data={tableData}
            enableStickyHeader
            enablePagination
            enableColumnFilters
            enableHiding = {false}
            enableSorting={false}
            initialState={{ density: "compact",}}
            muiPaginationProps={{
              rowsPerPageOptions: rowsPerPageOptions
            }}
            muiTableContainerProps={{
              sx: {
                maxHeight: "60vh",
                padding: "16px",
                paddingTop: "0px",
              },
            }}
            muiTableBodyCellProps={{
              sx: { border: "0.5px solid #e0e0e0" },
            }}
            muiTableHeadCellProps={{
              sx: { border: "0.5px solid #e0e0e0" },
            }}
            muiTableFooterRowProps={{
              sx: { fontWeight: "bold", backgroundColor: "#f1f1f1" },
            }}
            
            renderTopToolbarCustomActions={() => (
              <Box
                sx={{
          display: 'flex',
          gap: '16px',
          // padding: '8px',
          flexWrap: 'wrap',
        }}>
                  <Button
              variant="contained"
              color="info"
              onClick={()=>{setApprovalStatus('All');fetchTableData();}}
              >
                Total Entry: {totalEntry}
              </Button>
                  <Button
              variant="contained"
              color="primary"
              onClick={()=>{setApprovalStatus('Initiated');fetchTableData();}}
              >
                Total Initiated: {totalInitiated}
              </Button>
              <Button
              variant="contained"
              color="warning"
              onClick={()=>{setApprovalStatus('Pending');fetchTableData();}}
              >
                Total Pending: {totalPending}
              </Button>
              <Button
              variant="contained"
              color="success"
              onClick={()=>{setApprovalStatus('Approved');fetchTableData();}}
              >
                Total Approved: {totalApproved}
              </Button>
              <Button
              variant="contained"
              color="error"
              onClick={()=>{setApprovalStatus('Declined');fetchTableData();}}
              >
                Total Declined: {totalDeclined}
              </Button>
              
              
              </Box>
            )}
            renderBottomToolbarCustomActions={() => (
          <Box
          sx={{
          display: 'flex',
          gap: '16px',
          // padding: '8px',
          flexWrap: 'wrap',
        }}>
          <Button
          //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
          variant="contained"
          onClick={handleExportData}
          startIcon={<FileDownloadIcon />}
        >
          Export All Data
        </Button>
        </Box>
            )}
          />
          </Grid>
      )}
    </>
  );
};

export default ForwardingLetterDashboard;
